import { request } from '@umijs/max';
import { getAdminApiUrl } from '@/services/util';

/** 兑换余额充值码请求 */
export interface RedeemRequest {
  /** 兑换码（可带或不带连字符） */
  code: string;
}

/** 兑换余额充值码响应 */
export interface RedeemResponse {
  balanceTopUpAmountMicros?: number;
  balanceTopUpAmountYuan?: string;
  batchId?: string;
  batchName?: string;
  batchNo?: string;
  redeemedAt?: string;
  redeemedBy?: string;
  redeemedTenantId?: string;
  redemptionCodeId?: string;
}

/** 当前登录用户使用所属租户兑换充值码 */
export async function redeemBenefit(
  params: RedeemRequest,
  options?: { [key: string]: unknown },
) {
  return request<RedeemResponse>(getAdminApiUrl('redemption/redeem'), {
    method: 'POST',
    data: params,
    ...(options || {}),
  });
}
